type TTransformItem = { fn: string; args: number[] };

const parseTransformString: (transformString: string) => TTransformItem[] = (transformString) => {
  const transforms: TTransformItem[] = [];
  const regex: RegExp = /(\w+)\(([^)]+)\)/g;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(transformString)) !== null) {
    const fn: string = match[1];
    const args: number[] = match[2].split(',').map((s) => parseFloat(s.trim()));
    transforms.push({ fn, args });
  }

  return transforms;
};

export const parseCSSTransformString: (transformString: string) => {
  scaleX: number;
  scaleY: number;
} = (transformString) => {
  let scaleX: number = 1;
  let scaleY: number = 1;

  const transforms: TTransformItem[] = parseTransformString(transformString);

  for (const { fn, args } of transforms) {
    switch (fn) {
      case 'scale':
        if (args.length === 1) {
          scaleX *= args[0];
          scaleY *= args[0];
        } else {
          scaleX *= args[0];
          scaleY *= args[1];
        }
        break;
      case 'scaleX':
        scaleX *= args[0];
        break;
      case 'scaleY':
        scaleY *= args[0];
        break;
      case 'scale3d':
        scaleX *= args[0];
        scaleY *= args[1];
        break;
      case 'matrix':
        scaleX *= args[0];
        scaleY *= args[3];
        break;
      case 'matrix3d':
        scaleX *= args[0];
        scaleY *= args[5];
        break;
    }
  }

  return { scaleX, scaleY };
};
